import { enableProdMode, Injectable, importProvidersFrom } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import 'hammerjs';
import { environment } from '@env';
import { AppModule, MyHammerConfig } from './app/app.module';
import { AppComponent } from './app/app.component';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { HotelAvailabilityEffects } from '@store/hotel-availability/hotel-availability.effects';
import { DisneyTicketsEffects } from '@store/disney-tickets/disney-tickets.effects';
import { EffectsModule } from '@ngrx/effects';
import { appReducer } from '@store/app.reducer';
import { StoreModule } from '@ngrx/store';
import { MoebiusUIModule, MbProgressBarModule } from '@am/moebius';
import { CoreModule } from '@core/core.module';
import { AppRoutingModule } from './app/app-routing.module';
import { SharedModule } from './app/shared/shared.module';
import { provideAnimations } from '@angular/platform-browser/animations';
import { ModalsHotelsModule } from '@modals/modals.module';
import { AmExpertsToolsControlComponent } from '@am/experts-tools-control';
import { RouterModule } from '@angular/router';
import { HAMMER_GESTURE_CONFIG, HammerGestureConfig, BrowserModule, HammerModule, bootstrapApplication } from '@angular/platform-browser';

const MOEBIUS_IMPORTS = [MoebiusUIModule, MbProgressBarModule];
const NGRX_IMPORTS = [
  StoreModule.forRoot(appReducer),
  EffectsModule.forRoot([DisneyTicketsEffects, HotelAvailabilityEffects]),
  StoreDevtoolsModule.instrument({
    name: 'Fe-Hotels-App',
    logOnly: environment.production,
    maxAge: 25,
  }),
];



if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(RouterModule, AmExpertsToolsControlComponent, ModalsHotelsModule, BrowserModule, SharedModule, AppRoutingModule, HammerModule, CoreModule.forRoot(), ...MOEBIUS_IMPORTS, ...NGRX_IMPORTS),
        // importProvidersFrom(HammerModule),
        { provide: HAMMER_GESTURE_CONFIG, useClass: MyHammerConfig },
        provideAnimations(),
    ]
})
  .catch((err) => console.log(err));
